import { render, staticRenderFns } from "./NoticeMngtReg.vue?vue&type=template&id=b011b650"
import script from "./NoticeMngtReg.vue?vue&type=script&lang=js"
export * from "./NoticeMngtReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports